import React from "react";
import ReactDOM from "react-dom/client";
import "./styles.css";
import App from "./App";

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

const API_BASE = "https://empagij-backend-delsud.onrender.com";
const VAPID_PUBLIC_KEY =
  "BDinge_jIJxkS6sFmdCCNsxH-nBbrOJVyXqML1xbMYqU799LaYXG21RMvOV1eTXMLt-JoN3BZy4zrB-MmgWgToE";

function urlBase64ToUint8Array(base64String: string) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

export async function registerPush(): Promise<void> {
  try {
    if (!("serviceWorker" in navigator)) {
      console.log("registerPush: serviceWorker non supportato");
      return;
    }

    if (!("PushManager" in window)) {
      console.log("registerPush: PushManager non supportato");
      return;
    }

    if (!("Notification" in window)) {
      console.log("registerPush: Notification non supportato");
      return;
    }

    const token = localStorage.getItem("empagij_token");
    console.log("registerPush: token presente =", !!token);

    if (!token) {
      console.log("registerPush: token mancante, skip");
      return;
    }

    await navigator.serviceWorker.register("/sw.js");
    const registration = await navigator.serviceWorker.ready;

    console.log("registerPush: service worker ready", {
      scope: registration.scope,
      active: !!registration.active,
    });

    let permission = Notification.permission;
    console.log("registerPush: permission iniziale =", permission);

    if (permission === "default") {
      permission = await Notification.requestPermission();
      console.log("registerPush: permission dopo request =", permission);
    }

    if (permission !== "granted") {
      console.log("registerPush: permesso non concesso, skip");
      localStorage.removeItem("spesaconte_notifications_enabled");
      return;
    }

    const convertedKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);

    let subscription = await registration.pushManager.getSubscription();

    if (subscription) {
      console.log("registerPush: subscription già esistente", {
        endpoint: subscription.endpoint,
      });
    } else {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: convertedKey,
      });

      console.log("registerPush: nuova subscription creata", {
        endpoint: subscription.endpoint,
      });
    }

    const res = await fetch(`${API_BASE}/push/subscribe`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(subscription),
    });

    const data = await res.json().catch(() => ({}));

    console.log("registerPush: /push/subscribe status =", res.status, data);

    if (!res.ok || data?.ok === false) {
      throw new Error(data?.error || `HTTP ${res.status}`);
    }

    localStorage.setItem("spesaconte_notifications_enabled", "true");

    console.log("registerPush: subscription salvata sul backend");
  } catch (err) {
    console.error("registerPush ERROR:", err);
    localStorage.removeItem("spesaconte_notifications_enabled");
    throw err;
  }
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);